import React, {useCallback, useState} from 'react';
import useToggle from '../../../cmp/hooks/useToggle';
import FormGroup from '../../../cmp/form/FormGroup';
import {post} from '../../../../api';
import Input from '../../../cmp/form/Input';
import Modal from '../../../cmp/Modal';

function ShopifyTestForPurchase({plan_id, plan_title}) {
  const [visible, toggle] = useToggle()
  const [orderNumber, setOrderNumber] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const onSubmit = useCallback((e)=>{
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    setLoading(true)
    setError(null)
    // activate for plan
    post('/paymentplans/activate/store_purchase',{
      data:{
        order_number: orderNumber,
      },
      plan_id,
      payment_gateway:'store_purchase',
    }).then((data)=>{
      setLoading(false)
      if(data.success){
        window.location = "/"
      }else{
        setError(data.error)
      }
    }).catch((e)=>{
      console.log(e)
      setError("Network error");
      setLoading(false)
    })
  },[orderNumber])
  return (
      <>
        <Modal onSubmit={onSubmit}
               title={plan_title}
               okText={"Submit"}
               confirmLoading={loading}
               visible={visible} onClose={toggle}>
            <FormGroup label={"Order Number"} info={"Enter your purchased order number to verify"}>
              <Input value={orderNumber} onChange={setOrderNumber} />
            </FormGroup>
          {
            error ? <p className={"text-danger"}>{error}</p> : null
          }
        </Modal>
        <div className="text-center">
          <button className="btn btn-link already_purchased_link" onClick={toggle}>Already purchased ? Click here</button>
        </div>
      </>
  );
}

export default ShopifyTestForPurchase;
